import React from "react";
import { Switch } from 'react-router-dom';
import SmartPay from "../components/home";
import SmartPayError from "../components/error";
import { AutoCollect, AutoCollectResponse } from "../components/auto_collect";
import { BaseWrapper ,BaseResponseWrapper} from "../components/base";

// function getApplicationTitle() {
//     if (window.location.pathname.includes("easy_collect") || window.location.path.includes("auto-collect")) {
//         document.body.classList.add('new-body-class');
//         document.title = "EasyCollect"
//     }
//     else {
//         document.body.classList.add('body');
//         document.title = "Smart Pay"
//     }
// }

const SmartPayRouter = (props) => {
    const AppRoute = props.AppRoute;
    // getApplicationTitle()
    return (
        <Switch>
            <AppRoute exact path="/easy_collect/:url" component={BaseWrapper} />
            <AppRoute exact path="/easy_collect/:url/:txn_id/" component={BaseResponseWrapper} />
            <AppRoute exact path="/auto-collect/:url/" component={AutoCollect} />
            <AppRoute exact path="/auto-collect/:url/response/:reference_id/" component={AutoCollectResponse} />
            <AppRoute exact path="/:mid/:url" component={SmartPay} />
            <AppRoute exact path="/response/:mid/:url/:txn_id" component={SmartPay} />
            {/* <AppRoute exact path="/preview/:url" component={null} /> */}
            <AppRoute path="*" component={SmartPayError} />
        </Switch>
    )
}

export default SmartPayRouter;